import { Link } from 'react-router-dom';
import { characters } from '@/mocks/home';

export default function CharacterShowcase() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 text-xs font-medium rounded-full bg-accent-50 text-accent-700 mb-4 whitespace-nowrap">
            角色介绍
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
            邂逅你的<span className="text-primary-600">命运之人</span>
          </h2>
          <p className="text-foreground-500 max-w-2xl mx-auto leading-relaxed">
            每一位角色都拥有独特的性格与故事，深入了解他们，建立深厚的羁绊，共同书写属于你们的樱花物语。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {characters.map((char) => (
            <Link
              key={char.id}
              to={`/category/characters`}
              className="group relative bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={char.image}
                  alt={char.name}
                  title={`樱境物语角色 - ${char.name}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="text-accent-300 text-xs font-medium mb-1">{char.title}</p>
                  <h3 className="text-background-50 text-lg font-heading font-semibold">{char.name}</h3>
                </div>
              </div>
              <div className="p-5">
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-3">
                  {char.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/characters"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-medium rounded-full border border-primary-300 text-primary-600 hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部角色
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}